
    <div class="formgrid grid text-lg">
        <div class="col-12 md:col-6 lg:col-6 xl:col-4">
            <div class="field mb-2">
                <label for="zip" class="mb-1 font-bold text-xl">
                    <span translate>label.zip_code</span>*
                </label>
                <p-inputMask
                    inputId="zip"
                    [(ngModel)]="this.item.postalCode"
                    [mask]="zipCodeMask"
                    [placeholder]="zipCodeMask"
                    autoWidth="false"
                    (ngModelChange)="changeZipCode($event)"
                    styleClass="text-xl w-full">
                </p-inputMask>

            </div>
        </div>
        <div class="col-12 md:col-1 lg:col-1 xl:col-1 vertical-center">
            <div class="field mb-2 search-button">
                <p-button
                    icon="pi pi-search"
                    severity="info"
                    (click)="consultaCEP(this.item.postalCode)"
                    class="text-xl font-semibold">
                </p-button>
            </div>
        </div>
        <div class="col-12 md:col-5 lg:col-5 xl:col-7 vertical-center">
            <label for="zip" class="mb-1 font-bold text-xl">
                <span translate>label.reference</span>:
            </label>
            <div class="flex flex-wrap gap-3">
                <div class="flex align-items-center">
                    <p-radioButton name="reference1" class="ml-2" value="HOME" [(ngModel)]="item.reference" variant="filled"></p-radioButton>
                    <label for="reference1" class="ml-2">
                        <span class="text-900 text-xl font-medium" translate>label.addressHome</span>
                    </label>
                </div>
                <div class="flex align-items-center">
                   <p-radioButton name="reference2" value="WORK" [(ngModel)]="item.reference" variant="filled"></p-radioButton>
                    <label for="reference2" class="ml-2">
                        <span class="text-900 text-xl font-medium" translate>label.addressWork</span>
                    </label>
                </div>
            </div>
        </div>


        <!-- <div class="field col-12 md:col-3 lg:col-3 xl:col-3">
    <div class="field mb-2">
        <label for="country" class="mb-1 font-bold text-lg"><span translate>label.country</span></label>
        <sf-dropdown-generic InputId="country" [list]="companyStatusList" [id]="item.scCompanyStatusId" (selectedItemOutput)="reciverFeedbackCompanyStatus($event)" [disabled]="true" ></sf-dropdown-generic>
    </div>
</div> -->

        <div class="field col-12 md:col-12 lg:col-12 xl:col-12">
            <div class="field mb-2">
                <label for="route" class="mb-1 font-bold text-xl">
                    <span translate>label.street</span>*
                </label>
                <input pInputText
                    type="text"
                    id="route"
                    class="text-xl w-full"
                    [(ngModel)]="this.item.route"
                    [disabled]="cepWasSubmitted"
                    (blur)="setFormattedAddress()">
            </div>
        </div>
        <div class="field col-12 md:col-6 lg:col-3 xl:col-3">
            <div class="field mb-2">
                <label for="street_number" class="mb-1 font-bold text-xl">
                    <span translate>label.street_number</span>*
                </label>
                <input pInputText
                    type="text"
                    id="street_number"
                    class="text-xl w-full"
                    [(ngModel)]="this.item.streetNumber"
                    (blur)="setFormattedAddress()">
            </div>
        </div>
        <div class="field col-12 md:col-6 lg:col-3 xl:col-3">
            <div class="field mb-2">
                <label for="street_complement" class="mb-1 font-bold text-xl">
                    <span translate>label.street_complement</span>
                </label>
                <input  pInputText
                    type="text"
                    id="street_complement"
                    class="text-xl w-full"
                    [(ngModel)]="this.item.streetComplement"
                    (blur)="setFormattedAddress()">
            </div>
        </div>
        <div class="field col-12 md:col-12 lg:col-6 xl:col-6">
            <div class="field mb-2">
                <label for="neighborhood" class="mb-1 font-bold text-xl">
                    <span translate>label.neighborhood</span>*
                </label>
                <input pInputText
                    type="text"
                    id="neighborhood"
                    class="text-xl w-full"
                    [(ngModel)]="this.item.neighborhood"
                    [disabled]="cepWasSubmitted"
                    (blur)="setFormattedAddress()">
            </div>
        </div>

        <div class="field col-12 md:col-6 lg:col-6 xl:col-6 ">
            <div class="field mb-2">
                <label for="state" class="mb-1 font-bold text-lg"><span translate>label.state</span>*</label>

                <div *ngIf="cepWasSubmitted">
                    <input pInputText
                        type="text"
                        id="state"
                        required
                        class="w-full text-xl"
                        [(ngModel)]="this.item.state"
                        disabled
                    />
                </div>

                <div *ngIf="!cepWasSubmitted">
                    <sf-sc-state-dropdown
                        inputId="state"
                        [scCountryId]="item.scCountryId"
                        [scStateId]="item.scStateId"
                        (choseItem)="reciverFeedbackState($event)"
                        [disabled]="item.state == null ? true : false || cepWasSubmitted"
                        [style]="{'width':'100%'}"
                        (blur)="setFormattedAddress()">
                    </sf-sc-state-dropdown>
                </div>
            </div>
        </div>
        <div class="field col-12 md:col-6 lg:col-6 xl:col-6 ">
            <div class="field mb-2">
                <label for="scCityId" class="mb-1 font-bold text-lg"><span translate>label.city</span>*</label>

                 <div *ngIf="cepWasSubmitted">
                    <input pInputText
                        type="text"
                        id="state"
                        [ngModel]="item.city"
                        required
                        class="w-full text-xl"
                        disabled/>
                </div>

                <div *ngIf="!cepWasSubmitted">
                    <sf-sc-city-dropdown
                        inputId="scCityId"
                        [scStateId]="item.scStateId"
                        [scCityId]="item.scCityId"
                        (choseItem)="reciverFeedbackCity($event)"
                        [disabled]="item.state == null ? true : false || cepWasSubmitted"
                        [style]="{'width':'100%'}"
                        (blur)="setFormattedAddress()">
                    </sf-sc-city-dropdown>
                </div>
            </div>
        </div>

        <div class="field col-12 md:col-12 lg:col-12 xl:col-12">
            <div class="field mb-2">
                <label class="mb-1 font-bold text-xl"><span translate>label.address</span>:</label>
                <span class="ml-1 font-semibold text-xl">{{this.item.formattedAddress}}</span>
            </div>
        </div>

        <!-- <div class="field col-12 md:col-3 lg:col-3 xl:col-3">
            <div style="float: right;" class="field mb-2 search-button">
                <p-button [label]="'button.get_coordinate' | translate" severity="info" disabled="true"></p-button>
            </div>
        </div> -->
        <!-- <div class="field col-12 md:col-6 lg:col-3 xl:col-4 ">
            <div class="field mb-2">
                <label for="lat" class="mb-1 font-bold text-lg"><span translate>label.latitude</span></label>
                <input type="text" id="lat" pInputText
                    style="width: 100%;" disabled="true">
            </div>
        </div>
        <div class="field col-12 md:col-6 lg:col-3 xl:col-4 ">
            <div class="field mb-2">
                <label for="lng" class="mb-1 font-bold text-lg"><span translate>label.longitude</span></label>
                <input type="text" id="lng" pInputText
                    style="width: 100%;" disabled="true">
            </div>
        </div>
        <div class="field col-12 md:col-6 lg:col-6 xl:col-4">
            <div style="float: right;">
                <button pButton pRipple icon="pi pi-check" style="width: 110px; margin: 3px;"
                    class="p-button-primary p-mr-2 mt-3" [label]="'button.confirm' | translate"
                    disabled="true"></button>
            </div>
        </div> -->
        <div class="field col-12 mt-5">
            <div class="grid">
                <div class="col">
                    <div class="text-right">
                        <button pButton pRipple
                            icon="pi pi-times"
                            style="width: 150px; margin: 3px;"
                            class="text-xl font-semibold p-button-outlined"
                            size="large"
                            [label]="'button.cancel' | translate"
                            (click)="cancel();" >
                        </button>
                        <button pButton pRipple
                            icon="pi pi-save"
                            style="width: 150px; margin: 3px;"
                            class="text-xl font-semibold ml-3"
                            [label]="'button.save' | translate"
                            (click)="save();" >
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div style="float: right;">
                <button pButton type="submit" pRipple icon="pi pi-check" style="width: 110px; margin: 3px;"
                    class="p-button-success p-mr-2 mt-3" [label]="'button.confirm' | translate" [disabled]="!addressForm.valid"></button>
            </div> -->
        </div>
    </div>


